import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Hospital = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="hospital icon"
    className={`shrink-0 h-${size} w-${size} ${className}`}
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 7C8 5.34314 9.34315 4 11 4H37C38.6569 4 40 5.34315 40 7V44H8V7ZM11 6C10.4477 6 10 6.44771 10 7V42H38V7C38 6.44772 37.5523 6 37 6H11Z"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 32H30V44H18V32ZM20 34V42H28V34H20Z"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23 43V34H25V43H23Z"
    />
    <path className={pathClass} d="M23 10H25V16H23V10Z" />
    <path className={pathClass} d="M23 21H25V23H23V21Z" />
    <path className={pathClass} d="M23 27H25V29H23V27Z" />
    <path className={pathClass} d="M28 21H30V23H28V21Z" />
    <path className={pathClass} d="M13 21H15V23H13V21Z" />
    <path className={pathClass} d="M13 33H15V35H13V33Z" />
    <path className={pathClass} d="M13 27H15V29H13V27Z" />
    <path className={pathClass} d="M18 27H20V29H18V27Z" />
    <path className={pathClass} d="M33 33H35V35H33V33Z" />
    <path className={pathClass} d="M33 27H35V29H33V27Z" />
    <path className={pathClass} d="M28 27H30V29H28V27Z" />
    <path className={pathClass} d="M4 33H6V35H4V33Z" />
    <path className={pathClass} d="M4 27H6V29H4V27Z" />
    <path className={pathClass} d="M4 21H6V23H4V21Z" />
    <path className={pathClass} d="M42 33H44V35H42V33Z" />
    <path className={pathClass} d="M42 27H44V29H42V27Z" />
    <path className={pathClass} d="M42 21.1509H44V23.1509H42V21.1509Z" />
    <path className={pathClass} d="M33 21H35V23H33V21Z" />
    <path className={pathClass} d="M18 21H20V23H18V21Z" />
    <path className={pathClass} d="M21 12H27V14H21V12Z" />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M38 14H45C46.6569 14 48 15.3431 48 17V41C48 42.6569 46.6569 44 45 44H38V14ZM40 16V42H45C45.5523 42 46 41.5523 46 41V17C46 16.4477 45.5523 16 45 16H40Z"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 17C0 15.3431 1.34315 14 3 14H10V44H3C1.34315 44 0 42.6569 0 41V17ZM3 16C2.44772 16 2 16.4477 2 17V41C2 41.5523 2.44772 42 3 42H8V16H3Z"
    />
  </svg>
)
